import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=051eb9a9&scoped=true&"
import script from "./CustomerData.vue?vue&type=script&lang=ts&"
export * from "./CustomerData.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerData.vue?vue&type=style&index=1&id=051eb9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051eb9a9",
  null
  
)

export default component.exports